import React from "react";
import { compose, withHandlers, withPropsOnChange, withState } from "recompose";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import { keys } from "lodash";
import { ApiClient } from "services";
import { PendingButton } from "components/common";
import { NotificationManager } from "react-notifications";
import { Trans, withTranslation } from "react-i18next";

const DeleteModal = ({ isOpen, toggle, numSelected, onConfirm, pending, organisation=false }) => {
  return (
  <Modal isOpen={isOpen} toggle={toggle}>
    <ModalBody>
    {organisation ?
      <div className="text-center mt-2 alert alert-warning mb-0" role="alert">
        <h4 className="text-warning"><Trans>WARNING!</Trans></h4>
        <p className="my-1" style={{fontSize:"1.1em"}}><Trans>Are you sure to archive the selected organisation(s)?</Trans></p>
      </div>
      :
      <Trans>
        Are you sure to archive the {{ numSelected }} selected rows?
      </Trans>
    }
    </ModalBody>
    <ModalFooter>
      <PendingButton color={organisation ? "danger" : "primary"} pending={pending} onClick={onConfirm}>
        Confirm
      </PendingButton>{" "}
      <Button color="secondary" onClick={toggle}>
      <Trans>Cancel</Trans>
      </Button>
    </ModalFooter>
  </Modal>
);
}

const enhance = compose(
  withPropsOnChange(["client"], ({ client }) => ({
    client: client || ApiClient(),
  })),
  withState("pending", "setPending", false),
  withTranslation(),
  withPropsOnChange(["selected"], ({ selected: tmpSelected }) => {
    const selected = keys(tmpSelected);

    return {
      numSelected: selected.length,
      selected,
    };
  }),
  withHandlers({
    onConfirm:
      ({
        onConfirm,
        url,
        selected,
        onDeleted,
        isOpen,
        toggle,
        setPending,
        client,
        t,
        ...props
      }) =>
      () => {
        setPending(true);
        let promise = null;
        const failed = [];
        if (onConfirm) {
          promise = onConfirm();
        } else {
          let prepared_url = `${url}/${selected}`;
          try {
            let prefix = props.props.prefix;
            let org_id = props.props.organisation_data.organisation_id;
            prepared_url = prefix
              ? `${prefix}/${org_id}/${url}/${selected}`
              : prepared_url;
          } catch (e) {
            console.error(e);
          }
          promise = Promise.mapSeries(
            selected,
            (i) =>
              client.delete(prepared_url).catch(() => {
                failed.push(i);
              }),
            { concurrency: 1 }
          ).tap(() => {
            if (failed.length) {
              NotificationManager.error(
                t("{{count}} row(s) could not be deleted", {
                  count: failed.length,
                })
              );
            }
          });
        }

        promise
          .tap(() => {
            if (isOpen) toggle();
            onDeleted(failed.length ? failed : null);
          })
          .finally(() => setPending(false));
      },
  })
);

export default enhance(DeleteModal);
